module.exports = __webpack_public_path__ + "static/img/wx_qrcode.dfcee86b.png";